const PROMO = "Codice BENVENUTA10 · −10% sul tuo primo ordine";

const items = [
  "Fatto a mano in Italia",
  "Incisioni personalizzate",
  "Argento 925 e placcatura oro",
  "Regali unici per mamme e famiglie",
  "Spedizione in tutta Italia",
  "Lavorazione in 5/10 giorni lavorativi · Spedito con corriere assicurato",
  "Confezione regalo gratuita per ogni gioiello",
  PROMO,
  "Ma.Vi Gioielli",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      className="bg-[#37282B] py-5 overflow-hidden border-y border-[#E2A3B1]/30"
      data-testid="marquee-section"
    >
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center" data-testid={`marquee-item-${i}`}>
            {item === PROMO ? (
              <span className="mx-6 px-5 py-1.5 rounded-full bg-[#E2A3B1] text-[#37282B] text-xs sm:text-sm uppercase tracking-[0.18em] font-bold" data-testid="marquee-promo">
                {item}
              </span>
            ) : (
              <span className="font-serif-display italic text-lg sm:text-xl text-[#FDF8F7]/90 px-6">
                {item}
              </span>
            )}
            <span className="text-[#E2A3B1] text-sm">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
